"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaApiStatusStore = void 0;

var _generalStore = _interopRequireDefault(require("general-store"));

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _MetaApiConstants = require("./MetaApiConstants");

var _ActionTypes = _interopRequireDefault(require("crm_data/actions/ActionTypes"));

var apiStatus = _LoadingStatus.EMPTY;

var MetaApiStatusStore = _generalStore.default.define().defineGet(function () {
  return apiStatus;
}).defineResponseTo(_MetaApiConstants.META_API_FINISHED, function (data) {
  return apiStatus = data;
}).defineResponseTo(_ActionTypes.default.NAVIGATE, function () {
  return apiStatus = _LoadingStatus.EMPTY;
}).register();

exports.MetaApiStatusStore = MetaApiStatusStore;